import { defineComponent } from 'vue';
import AppNotifications from '@/components/shared/AppNotifications.vue';
import SiteFooter from '@/components/layout/SiteFooter.vue';
import SiteHeader from '@/components/layout/SiteHeader.vue';
import { CustomerRoutes } from '@/router/index';
export default defineComponent({
    inject: ['siteIsInMaintenance', 'maintenanceMessage'],
    name: 'CustomerApp',
    components: {
        SiteHeader,
        SiteFooter,
        AppNotifications
    },
    props: {
        isTWC: {
            required: true,
            type: Boolean
        }
    },
    computed: {
        hasUserData() {
            return this.$store.getters.userIsEmpty;
        },
        title() {
            return this.$route.name !== 'Home' ? this.$route.name : '';
        },
        routes() {
            if (this.siteIsInMaintenance) {
                return [];
            }
            return CustomerRoutes;
        }
    },
    created() {
        document.title = this.isTWC ? 'Adaptive Vehicles and Equipment' : 'Texas Independent Living Centers';
        if (this.siteIsInMaintenance && this.$route.name !== 'Maintenance') {
            this.$router.replace({ name: 'Maintenance' });
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.$store.state.window.width = window.innerWidth;
            this.$store.state.window.height = window.innerHeight;
        });
    }
});
